<template>
  <div v-resize="onResize" class="product-pictures__wrapper d-flex">
    <div class="swiper-top">
      <swiper ref="swiperTop" class="swiper" v-bind="swiperOptionTop" @swiper="initMainSwiper" @slide-change-transition-end="onSlideTopChangeEnd">
        <swiper-slide v-for="(image, idx) in images" :key="idx">
          <div class="product-picture" :style="generateBGImageStyle(image)" @click="openDetailModal" />
        </swiper-slide>
      </swiper>

      <v-chip v-if="hideRightSide" class="swiper-pagination wd-text-white" color="black50" label size="small">
        {{ `${paginationNum}/${images.length}` }}
      </v-chip>
    </div>

    <div v-if="!hideRightSide" class="swiper-thumbs">
      <v-btn
        class="swiper-button swiper-button__prev"
        :class="{ hidden: hiddenSwiperBeginning }"
        width="100%"
        height="32"
        variant="text"
        @click="slideMove('prev')"
      >
        <funnow-icon max-width="24" :image-path="'chevron-up.svg'" />
      </v-btn>

      <swiper ref="swiperThumbs" class="swiper" v-bind="swiperOptionThumbs" @swiper="initRightSwiper" @slide-change-transition-end="onSlideChangeEnd">
        <swiper-slide v-for="(image, idx) in images" :key="idx">
          <div class="product-picture product-picture__thumbs" :style="generateBGImageStyle(image)" @click.stop="toSlide(idx)" />
        </swiper-slide>
      </swiper>

      <v-btn
        class="swiper-button swiper-button__next"
        :class="{ hidden: hiddenSwiperEnd }"
        width="100%"
        height="32"
        variant="text"
        @click="slideMove('next')"
      >
        <funnow-icon max-width="24" :image-path="'chevron-down.svg'" />
      </v-btn>
    </div>

    <image-detail-modal ref="imageDetailModal" :images="images" :slide-number="paginationNum" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { Swiper, SwiperSlide } from 'swiper/vue'

import ImageDetailModal from '@/components/dialog/image-detail-modal.vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'

import utils from '@/utils'

// let resizeSwiperTimeout = null
export default {
  name: 'AlbumSwiper',
  components: {
    Swiper,
    SwiperSlide,
    ImageDetailModal,
    FunnowIcon,
  },
  props: {
    images: { type: Array, default: () => [] },
    hideRightSide: { type: Boolean, default: false },
  },
  setup() {
    const { swiper: mainSwiper, initSwiper: initMainSwiper } = useSwiperFactory()
    const { swiper: rightSwiper, initSwiper: initRightSwiper } = useSwiperFactory()

    return {
      mainSwiper,
      initMainSwiper,
      rightSwiper,
      initRightSwiper,
    }
  },
  data() {
    const slidesPerGroup = 5
    return {
      hiddenSwiperBeginning: true,
      hiddenSwiperEnd: false,
      thumbsSlidesPerGroup: slidesPerGroup,
      swiperOptionTop: {
        loop: true,
      },
      swiperOptionThumbs: {
        slidesPerGroup: slidesPerGroup,
        width: 92,
        height: 92,
        direction: 'vertical',
        spaceBetween: 16,
        updateOnWindowResize: true,
      },
      paginationNum: 1,
    }
  },
  computed: {
    ...mapGetters({}),
  },
  created() {},
  mounted() {
    if (this.thumbsSlidesPerGroup > this.images.length) {
      this.hiddenSwiperEnd = true
    }
  },
  updated() {},
  methods: {
    // resizeSwiper() {
    //   const $swiperTop = this.$refs.swiperTop
    //   if ($swiperTop) {
    //     $swiperTop.$swiper.resize.resizeHandler()
    //   }
    // },
    onResize() {
      // clearTimeout(resizeSwiperTimeout)
      // resizeSwiperTimeout = setTimeout(this.resizeSwiper, 500)
    },
    generateBGImageStyle(path) {
      return `background-image: url('${utils.imageUrl(path)}')`
    },
    toSlide(pageNum) {
      this.paginationNum = pageNum + 1
      this.mainSwiper.slideTo(pageNum, 100, false)
    },
    slideMove(type) {
      this.rightSwiper?.[type === 'next' ? 'slideNext' : 'slidePrev']()
    },
    onSlideTopChangeEnd(swiper) {
      this.paginationNum = swiper.activeIndex + 1
    },
    onSlideChangeEnd(swiper) {
      this.$nextTick(() => {
        if (this.rightSwiper) {
          // this.resizeSwiper()
          const groupCount = this.rightSwiper.activeIndex + this.thumbsSlidesPerGroup
          this.hiddenSwiperBeginning = this.rightSwiper.isBeginning
          this.hiddenSwiperEnd = groupCount >= this.images.length
        }
      })
    },
    openDetailModal() {
      this.$refs.imageDetailModal.showModal()
    },
  },
}
</script>

<style scoped lang="scss" src="@/assets/sass/components/slide/album-swiper.scss"></style>
